import React, {useState, useEffect, useRef} from "react";
import {Card, CardBody, Container, Row, Col} from "reactstrap";
import BreadCrumb from "../../../Components/Common/BreadCrumb";

import {Pagination} from "antd";
import Select from "react-select"; // Adicionado import para Select

import {Link} from "react-router-dom";
import ApiService from "../util/ApiService";
import Swal from "sweetalert2";
import LoadingScreen from "../util/LoadingScreen";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import UsersSearch from "../dashboard/calender/UsersSearch";
import CustomPagination from "../util/CustomPagination";
import DepartmentUserModal from "./DepartmentUserModal";
import DepartmentEditModal from "./DepartmentEditModal";
import DepartmentUserListModal from "./DepartmentUserListModal";
import ImportModal from "../import/ImportModal";
import DropdownPortal from "../util/DropdownPortal";
import AddUserToDepartmentModal from "./AddUserToDepartmentModal";
import HospitalValueModal from "../hospital/HospitalValueModal";
import DepartmentValueModal from "./DepartmentValueModal";

const Department = () => {
    document.title = "Departamento | Plantão Rápido";

    const [showAddModal, setShowAddModal] = useState(false);
    const buttonRefs = useRef({});
    const [dropdownOpenId, setDropdownOpenId] = useState(null);

    const refUserSearch = useRef(null);
    const [loadingPage, setLoadingPage] = useState(false);
    const [departments, setDepartments] = useState([]);
    const [department, setDepartment] = useState(null);
    const [departmentsFilter, setDepartmentsFilter] = useState([]);
    const [filters, setFilters] = useState({
        status: null,
        user_id: '',
    });

    const options = [
        {value: "S", label: "Ativo"},
        {value: "N", label: "Inativo"},
    ];

    const [pagination, setPagination] = useState({current: 1, pageSize: 10, total: 0, lastPage: 0});
    const [showImportModal, setShowImportModal] = useState(false);
    const [showDepartmentModal, setShowDepartmentModal] = useState(false);
    const [showDepartmentValueModal, setShowDepartmentValueModal] = useState(false);
    const [showDepartmentUserModal, setShowDepartmentUserModal] = useState(false);
    const [showDepartmentUserListModal, setShowDepartmentUserListModal] = useState(false);
    const [importType, setImportType] = useState(null);
    const [loadingDepartment, setLoadingDepartment] = useState(false);

    useEffect(() => {
        fetchDepartment();
        fetchDepartmentsFilter();
    }, []);

    const fetchDepartmentsFilter = async () => {
        try {
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/list-department`,
                {all: true, status: 'S'},
                true
            );

            if (response.code === 200) {
                const {data} = ApiService.handleApiResponse(response);

                setDepartmentsFilter(
                    Array.isArray(data) ? data : []
                );
            } else {
                Swal.fire("Erro", "Erro ao carregar os departamentos.", "error");
            }
        } catch (error) {
            ApiService.handleApiError(error);
            setDepartments([]);
        }
    };


    const fetchDepartment = async (page = 1) => {
        try {
            setLoadingDepartment(true);

            const param = {
                pagination: pagination.pageSize,
                page: page,
                user_id: filters?.user_id || null,
                status: filters?.status?.value || null,
                departament_id: filters?.departament_id || null
            };

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/list-department`,
                param,
                true
            );

            const {data, pagination: pagInfo} = ApiService.handleApiResponse(response);
            setDepartments(data || []);
            setPagination(pagInfo || {current: 1, pageSize: 10, total: 0});

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingDepartment(false);
        }
    };
    const handleImportButtonClick = (type) => {
        setImportType(type);
        setShowImportModal(true);
    };
    const handleChange = (selectedOption) => {
        setFilters((prevFilters) => ({
            ...prevFilters,
            status: selectedOption,
        }));
    };
    const handleClearFilters = () => {
        setFilters({
            status: null,
            user_id: null,
            departament_id: null,
            department: null,
        });

        // Chamar a função clearHospital() no HospitalSearch
        if (refUserSearch.current) {
            refUserSearch.current.clearUser();
        }
    };

    const handleDepartmentModalClose = (save = false) => {
        setShowDepartmentModal(false);
        if (save) {
            fetchDepartment(pagination.current);
        }
    };

    const handleDepartmentUserModalClose = () => {
        setShowDepartmentUserModal(false);
        setDepartment(null);
    };

    const handleDepartmentUserListModalClose = () => {
        setShowDepartmentUserListModal(false);
        setDepartment(null);
    };


    const handleModalEdit = (department = null) => {
        setDepartment(department);
        setShowDepartmentModal(true);
    }


    const handleDepartmentUserModal = (department = null) => {
        setDepartment(department);
        setShowDepartmentUserListModal(true);
    }
    const handleDepartmentUserValueModal = (department = null) => {
        setDepartment(department);
        setShowDepartmentValueModal(true);
    }

    const handleDepartmentUserNew = (department = null) => {
        setDepartment(department);
        setShowAddModal(true);
    }


    const handleModalUser = (department) => {
        setShowDepartmentUserModal(true);
    }

    const handlePageChange = (page) => {
        fetchDepartment(page);
    };


    const handleImportModalClose = () => {
        setShowImportModal(false);
        setImportType(null);
    };

    const handleDepartmentValueModalClose = () => {
        setShowDepartmentValueModal(false);
    };


    const handleStatus = async (department, status) => {
        try {
            setLoadingPage(true);
            const updatedDepartment = {...department, status};

            // Enviar requisição para registrar a alteração
            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/register`,
                updatedDepartment,
                true
            );

            setLoadingPage(false);

            if (response.code === 200) {
                Swal.fire("Sucesso", "Status do departamento alterado com sucesso!", "success");

                // Atualizar a lista de departamentos no estado
                const updatedDepartments = departments.map(dep =>
                    dep.id === department.id ? {...dep, status} : dep
                );

                setDepartments(updatedDepartments);
            } else {
                Swal.fire("Erro", "Erro ao registrar hospital", "error");
            }
        } catch (error) {

            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };


    const handleUserRemoveAll = async (department) => {
        const confirm = await Swal.fire({
            title: "Tem certeza?",
            text: "Todos os usuários serão removidos deste departamento!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#d33",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Sim, remover todos",
            cancelButtonText: "Cancelar"
        });

        if (!confirm.isConfirmed) return;

        try {
            setLoadingPage(true);

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/remove-user-all`,
                { department_id: department.id },
                true
            );

            if (response.code === 200) {
                Swal.fire("Sucesso", "Todos os usuários foram removidos com sucesso!", "success").then(() => {
                    fetchDepartment();
                });
            }
        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };

    const handleUserNewAll = async (department) => {
        const confirm = await Swal.fire({
            title: "Adicionar todos os usuários?",
            text: "Todos os usuários disponíveis serão vinculados a este departamento.",
            icon: "question",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#6c757d",
            confirmButtonText: "Sim, adicionar todos",
            cancelButtonText: "Cancelar"
        });

        if (!confirm.isConfirmed) return;

        try {
            setLoadingPage(true);

            const response = await ApiService.send(
                "post",
                `${process.env.REACT_APP_URL_API}departments/add-user-all`,
                { department_id: department.id },
                true
            );

            if (response.code === 200) {
                Swal.fire("Sucesso", "Todos os usuários foram adicionados com sucesso!", "success").then(() => {
                    fetchDepartment();
                });

            }

        } catch (error) {
            ApiService.handleApiError(error);
        } finally {
            setLoadingPage(false);
        }
    };



    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid>
                    <BreadCrumb title="Departamento" pageTitle="Configuração"/>
                    <Row>
                        {loadingPage && <LoadingScreen/>}

                        <div className="button-group mb-3">
                            <button type="button" className="btn btn-outline-dark  mr-1  me-2"
                                    onClick={() => handleImportButtonClick(5)}>
                                <i className="fa fa-upload"></i> Importar Vínculo
                            </button>
                        </div>
                        <div className="row mt-12 mb-12">
                            <div className="col-md-4">
                                <div className="form-group">
                                    <label>Situação</label>
                                    <Select
                                        key={filters.status ? "has-value" : "no-value"} // Altera a key ao limpar
                                        options={options}
                                        value={filters.status} // Garante que o valor seja atualizado corretamente
                                        onChange={handleChange}
                                        placeholder="Selecione"
                                        isClearable
                                        styles={{
                                            control: (provided) => ({
                                                ...provided,
                                                width: '100%',
                                            }),
                                        }}
                                    />

                                </div>
                            </div>
                            <div className="col-md-4">
                                <UsersSearch
                                    ref={refUserSearch}
                                    onUserSelect={(user) =>
                                        setFilters((prevFilters) => ({
                                            ...prevFilters,
                                            user_id: user?.value || "",
                                        }))
                                    }
                                />
                            </div>
                            <div className="col-md-4 form-group">
                                <label>Departamentos</label>
                                <Select
                                    isClearable
                                    options={departmentsFilter.map((dept) => ({
                                        value: dept.id,
                                        label: dept.name,
                                    }))}
                                    value={filters.department || null}
                                    onChange={(dept) =>
                                        setFilters((prevFilters) => ({
                                            ...prevFilters,
                                            departament_id: dept ? Number(dept.value) : null,
                                            department: dept
                                        }))
                                    }
                                    classNamePrefix="select"
                                    placeholder="Selecionar Departamento..."
                                    menuPortalTarget={document.body}
                                    styles={{
                                        menuPortal: base => ({...base, zIndex: 9999}),
                                        menu: base => ({...base, zIndex: 9999}),
                                    }}
                                />


                            </div>

                        </div>

                        <div className="row mt-4">
                            <div className="col-md-12 d-flex justify-content-end">

                                <button type="button" className="btn  mr-1  me-2"
                                        onClick={() => handleClearFilters()}>
                                    <i className="fa fa-eraser"></i> Limpar Filtros
                                </button>

                                <button type="button" className="btn btn-info mr-1  me-2"
                                        onClick={() => handleModalUser()}>
                                    <i className="fa fa-plus"></i> Vincular por Plantonista
                                </button>

                                <button type="button" className="btn btn-info mr-1  me-2"
                                        onClick={() => handleModalEdit()}>
                                    <i className="fa fa-plus"></i> Cadastrar
                                </button>

                                <button type="button"
                                        className="btn btn-success"
                                        onClick={() => fetchDepartment(1)}
                                        disabled={loadingDepartment}
                                >
                                    {loadingDepartment ? (
                                        <>
                                                    <span className="spinner-border spinner-border-sm me-2"
                                                          role="status" aria-hidden="true"></span>
                                            Buscando...
                                        </>
                                    ) : (
                                        <>
                                            <i className="fa fa-search me-2"></i> Buscar
                                        </>
                                    )}
                                </button>

                            </div>
                        </div>


                        {/* Lista de Funcionários */}
                        <div className="list-container mt-4">
                            {loadingDepartment ? (
                                <Skeleton count={5} height={120}/>
                            ) : departments.length > 0 ? (
                                departments.map((department) => (
                                    <Col lg={12} key={department.id}>
                                        <Card className="mb-1 p-2 shadow-sm card-hover">
                                            <CardBody
                                                className="card-body d-flex justify-content-between align-items-center p-2">

                                                <div className="col-6 ">
                                                    <h5 className="doc-name">{department?.name || "Usuário não identificado"}</h5>

                                                    {/* Exibe as especialidades como tags */}


                                                    <p className="text-muted mb-1">
                                                        {department.status === 1 ? (
                                                            <span
                                                                className="badge bg-success d-inline-flex align-items-center me-2">
                                                                                  <i className="fa fa-check me-2"></i> Situação Ativo
                                                                                </span>
                                                        ) : (
                                                            <span
                                                                className="badge bg-danger d-inline-flex align-items-center me-2">
                                                                                      <i className="fa fa-times me-2"></i> Situação Inativo
                                                                                    </span>

                                                        )}

                                                        {department.is_standard === 1 ? (
                                                            <span
                                                                className="badge bg-success d-inline-flex align-items-center me-2">
                                                                                  <i className="fa fa-check me-2"></i> Padrão para todos
                                                                                </span>
                                                        ) : (
                                                            <span
                                                                className="badge bg-danger d-inline-flex align-items-center me-2">
                                                                                      <i className="fa fa-times me-2"></i> Não Padrão
                                                                                    </span>

                                                        )}
                                                    </p>


                                                    <p>
                                                        {department.specialties_department?.map((item, index) => (
                                                            item.specialty && (
                                                                <span
                                                                    key={index}
                                                                    className="badge bg-primary d-inline-flex align-items-center me-2"
                                                                >
                                                                <i className="fa fa-id-badge me-2"></i> {item.specialty.name}
                                                            </span>
                                                            )
                                                        ))}

                                                    </p>

                                                    <p className="text-muted mb-1">
                                                        <i className="fa fa-file-text-o text-info me-2"></i>
                                                        {department?.description ? department.description : "Descrição não informada"}
                                                    </p>
                                                    {department.value > 0 && (
                                                        <p className="text-muted mb-1">
                                                            <i className="fa fa-dollar text-info"
                                                               style={{marginRight: "8px"}}></i>
                                                            {department.value?.toLocaleString('pt-BR', {
                                                                minimumFractionDigits: 2,
                                                                maximumFractionDigits: 2
                                                            })} reais
                                                        </p>
                                                    )}


                                                </div>


                                                <h6 className="text-muted mb-1">
                                                    <i className="fa fa-user me-2"></i>
                                                    {department.user_count}
                                                </h6>

                                                <div className="dropdown">
                                                    <button
                                                        className="btn btn-outline-info btn-sm"
                                                        type="button"
                                                        ref={(el) => (buttonRefs.current[department.id] = el)}
                                                        onClick={() =>
                                                            setDropdownOpenId(dropdownOpenId === department.id ? null : department.id)
                                                        }
                                                    >
                                                        <i className="fa fa-ellipsis-v"></i> Opções
                                                    </button>

                                                    <DropdownPortal
                                                        parentRef={{current: buttonRefs.current[department.id]}}
                                                        show={dropdownOpenId === department.id}
                                                        onClose={() => setDropdownOpenId(null)}
                                                    >
                                                        <ul className="dropdown-menu show">
                                                            {department.name !== "Livre" && (
                                                                <li>
                                                                    <button className="dropdown-item"
                                                                            onClick={() => {
                                                                                handleModalEdit(department);
                                                                                setDropdownOpenId(null);
                                                                            }}>
                                                                        <i className="fa fa-edit me-2"></i> Editar
                                                                    </button>
                                                                </li>
                                                            )}

                                                            <li className="p-0">
                                                                <div className="ms-3">
                                                                    <i className="fa fa-user me-2"></i> Plantonista
                                                                    <ul className="list-group list-group-flush ms-3 mt-2">
                                                                        <li>
                                                                            <button className="dropdown-item"
                                                                                    onClick={() => {
                                                                                        handleUserNewAll(department);
                                                                                        setDropdownOpenId(null);
                                                                                    }}>
                                                                                <i className="fa fa-users me-2"></i> Adicionar
                                                                                Todos
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item"
                                                                                    onClick={() => {
                                                                                        handleDepartmentUserNew(department);
                                                                                        setDropdownOpenId(null);
                                                                                    }}>
                                                                                <i className="fa fa-plus me-2"></i> Adicionar
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item"
                                                                                    onClick={() => {
                                                                                        handleUserRemoveAll(department);
                                                                                        setDropdownOpenId(null);
                                                                                    }}>
                                                                                <i className="fa fa-user-times me-2"></i> Remover
                                                                                Todos
                                                                            </button>
                                                                        </li>
                                                                        <li>
                                                                            <button className="dropdown-item"
                                                                                    onClick={() => {
                                                                                        handleDepartmentUserModal(department);
                                                                                        setDropdownOpenId(null);
                                                                                    }}>
                                                                                <i className="fa fa-list me-2"></i> Listar
                                                                            </button>
                                                                        </li>
                                                                    </ul>
                                                                </div>
                                                            </li>
                                                            <li>
                                                                <button className="dropdown-item"
                                                                        onClick={() => {
                                                                            handleDepartmentUserValueModal(department);
                                                                        }}>
                                                                    <i className="fa fa-dollar me-2"></i> Valor Hora
                                                                </button>
                                                            </li>


                                                            <li>
                                                                <button
                                                                    className={`dropdown-item ${department.status === 1 ? "text-danger" : "text-success"}`}
                                                                    onClick={() => handleStatus(department, department.status === 1 ? 0 : 1)}
                                                                >
                                                                    <i className={`fa ${department.status === 1 ? "fa-close" : "fa-check"} me-2`}></i>
                                                                    {department.status === 1 ? "Inativar" : "Ativar"}
                                                                </button>
                                                            </li>
                                                        </ul>
                                                    </DropdownPortal>
                                                </div>

                                            </CardBody>
                                        </Card>
                                    </Col>
                                ))
                            ) : (
                                <div className="text-center">
                                    <div className="alert alert-primary" role="alert">Nenhum funcionário encontrado.
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Paginação */}
                        <CustomPagination
                            onChange={handlePageChange}
                            pagination={pagination}
                        />


                        {showDepartmentModal && (
                            <DepartmentEditModal
                                show={showDepartmentModal}
                                onHide={handleDepartmentModalClose}
                                department={department}
                            />
                        )}
                        {showDepartmentUserModal && (
                            <DepartmentUserModal
                                show={showDepartmentUserModal}
                                onHide={handleDepartmentUserModalClose}
                                department={department}
                            />
                        )}
                        {showDepartmentUserListModal && (
                            <DepartmentUserListModal
                                show={showDepartmentUserListModal}
                                onHide={handleDepartmentUserListModalClose}
                                department={department}
                            />
                        )}
                        {showImportModal && (
                            <ImportModal
                                show={showImportModal}
                                onHide={handleImportModalClose}
                                importType={importType}
                            />
                        )}

                        {showAddModal && (
                            <AddUserToDepartmentModal
                                show={showAddModal}
                                onHide={() => setShowAddModal(false)}
                                department={department}
                                onSuccess={() => fetchDepartment(1)}
                            />
                        )}


                        <DepartmentValueModal
                            show={showDepartmentValueModal}
                            handleClose={handleDepartmentValueModalClose}
                            department={department}
                        />


                    </Row>
                </Container>
            </div>
        </React.Fragment>

    );
};

export default Department;
